import { createContext } from "react";
import type { WorkoutsActionsContextType } from "./WorkoutsActionsContext.types";

const WorkoutsActionsContext = createContext<WorkoutsActionsContextType | undefined>(undefined);
WorkoutsActionsContext.displayName = "WorkoutsActionsContext";

export default WorkoutsActionsContext;
